import React from 'react'
import {
  Form,
  Button,
  Message,
  Modal,
  Header,
} from 'semantic-ui-react'
import TypeEditorEnumPane from './TypeEditorEnumPane.js'
import TypeEditorExampleSelector from './TypeEditorExampleSelector.js'
import {cloneType} from './type.js'
import {coerceId} from './utils.js'

class TypeEditorModal extends React.Component {
  constructor(props) {
    super(props);
    // props: type, open, onSubmit, onCancel
    this.state = {
      type: cloneType(this.props.type),
      exampleItem: {},
    }
  }
  handleToggleExampleItem = (eid, cid)=>{
    this.setState(prevState=>{
      const oldExampleItem = prevState.exampleItem;
      const newExampleItem = {...oldExampleItem};
      if (newExampleItem[eid]===cid) {
        delete newExampleItem[eid];
      } else {
        newExampleItem[eid] = cid;
      }
      return {
        exampleItem: newExampleItem
      };
    });
  }
  handleAddEnum = ()=>{
    console.log("TypeEditorModal::handleAddEnum()");
    const ids = this.state.type.map(e=>e.id);
    let i = 1;
    function exists(nid) { return ids.find(id=>id===nid); }
    while (exists('E'+i)) {
      i++;
    }
    const newId = 'E'+i;
    const newEnum = {
      id: newId,
      name: newId,
      choices: [],
    }
    this.setState(prevState=>{
      return { type: [...prevState.type, newEnum] }
    });
  }
  handleSetEnumId = (ei, newId)=>{
    console.log("TypeEditorModal::onSetEnumId()", ei, newId);
    newId = coerceId(newId);
    this.setState(prevState=>{
      // type
      const oldE = prevState.type[ei];
      const newE = {...oldE, id: newId};
      const oldT = prevState.type;
      const newT = oldT.map((e,i)=>i===ei?newE:e);
      // exampleItem
      const oldKey = oldE.id;
      const newKey = newId;
      const oldExampleItem = prevState.exampleItem;
      const value = oldExampleItem[oldKey];
      const newExampleItem = {...oldExampleItem};
      if (oldKey) {
        delete newExampleItem[oldKey];
      }
      if (value) {
        newExampleItem[newKey] = value;
      }
      // update
      return {
        type: newT,
        exampleItem: newExampleItem,
      };
    });
  }
  handleSetEnumField = (ei, fieldName, newValue)=>{
    console.log("TypeEditorModal::handleSetEnumField()", ei, newValue);
    this.setState(prevState=>{
      const oldE = prevState.type[ei];
      const newE = {...oldE, [fieldName]: newValue};
      const oldT = prevState.type;
      const newT = oldT.map((e,i)=>i===ei?newE:e);
      return {
        type: newT
      };
    });
  }
  handleRemoveEnum = (ei)=>{
    console.log("TypeEditorModal::handleRemoveEnum()", ei);
    this.setState(prevState=>{
      // type
      const oldE = prevState.type[ei];
      const oldT = prevState.type;
      const newT = oldT.filter((e,i)=>i!==ei);
      // exampleItem
      const oldKey = oldE.id;
      const oldExampleItem = prevState.exampleItem;
      const newExampleItem = {...oldExampleItem};
      if (oldKey) {
        delete newExampleItem[oldKey];
      }
      // update
      return {
        type: newT,
        exampleItem: newExampleItem
      }
    });
  }
  handleAddEnumChoice = (ei)=>{
    console.log("TypeEditorModal::handleAddEnumChoice()", ei);
    this.setState(prevState=>{
      const oldT = prevState.type;
      const oldE = prevState.type[ei];
      const ids = oldE.choices.map(c=>c.id);
      let i = 1;
      function exists(nid) { return ids.find(id=>id===nid); }
      while (exists('C'+i)) {
        i++;
      }
      const newId = 'C'+i;
      const newC = {
        id: newId,
        name: newId,
        description: '',
        color: 'green',
        icon: 'check'
      }
      const newCs = [...oldE.choices, newC];
      const newE = {...oldE, choices: newCs};
      const newT = oldT.map((e,i)=>i===ei?newE:e);
      return {
        type: newT,
      };
    });
  }
  handleSetEnumChoiceField = (ei, ci, fieldName, newValue)=>{
    console.log("TypeEditorModal::handleSetEnumChoiceField()", ei, ci, fieldName, newValue);
    this.setState(prevState=>{
      // type
      const oldT = prevState.type;
      const oldE = oldT[ei];
      const oldCs = oldE.choices;
      const oldC = oldCs[ci];
      const newC = {...oldC, [fieldName]: newValue};
      const newCs = oldCs.map((c,i)=>i===ci?newC:c);
      const newE = {...oldE, choices: newCs};
      const newT = oldT.map((e,i)=>i===ei?newE:e);
      // exampleItem
      const exampleItemMixin = {};
      if (fieldName==='id') {
        const key = oldE.id;
        const oldValue = oldC.id;
        const oldExampleItem = prevState.exampleItem;
        if (oldExampleItem[key]===oldValue) {
          const newExampleItem = {...oldExampleItem};
          newExampleItem[key] = newValue;
          exampleItemMixin.exampleItem = newExampleItem;
        }
      }
      // update
      return {
        type: newT,
        ...exampleItemMixin
      };
    });
  }
  handleSetEnumChoiceId = (ei, ci, newId)=>{
    console.log("TypeEditorModal::handleSetEnumChoiceId()", ei, ci, newId);
    this.handleSetEnumChoiceField(ei, ci, 'id', coerceId(newId));
  }
  handleSetEnumChoiceName = (ei, ci, newName)=>{
    console.log("TypeEditorModal::handleSetEnumChoiceName()", ei, ci, newName);
    this.handleSetEnumChoiceField(ei, ci, 'name', newName);
  }
  handleSetEnumChoiceDescription = (ei, ci, newDescription)=>{
    console.log("TypeEditorModal::handleSetEnumChoiceDescription()", ei, ci, newDescription);
    this.handleSetEnumChoiceField(ei, ci, 'description', newDescription);
  }
  handleSetEnumChoiceColor = (ei, ci, newColor)=>{
    console.log("TypeEditorModal::handleSetEnumChoiceColor()", ei, ci, newColor);
    this.handleSetEnumChoiceField(ei, ci, 'color', newColor);
  }
  handleSetEnumChoiceIcon = (ei, ci, newIcon)=>{
    console.log("TypeEditorModal::handleSetEnumChoiceIcon()", ei, ci, newIcon);
    this.handleSetEnumChoiceField(ei, ci, 'icon', newIcon);
  }
  handleRemoveEnumChoice = (ei, ci)=>{
    console.log("TypeEditorModal::handleRemoveEnumChoice()", ei, ci);
    this.setState(prevState=>{
      // type
      const oldT = prevState.type;
      const oldE = oldT[ei];
      const oldCs = oldE.choices;
      const newCs = oldCs.filter((c,i)=>i!==ci);
      const newE = {...oldE, choices: newCs};
      const newT = oldT.map((e,i)=>i===ei?newE:e);
      // exampleItem
      const key = oldE.id;
      const oldExampleItem = prevState.exampleItem;
      const value = oldExampleItem[key];
      const newExampleItem = {...oldExampleItem};
      if (newExampleItem[key]===value) {
        delete newExampleItem[key];
      }
      // update
      return {
        type: newT,
        exampleItem: newExampleItem
      };
    });
  }
  getTypeErrors = ()=> {
    const errors = [];
    // duplicate eids?
    const eids = this.state.type.map(e=>e.id);
    if (new Set(eids).size<eids.length) {
      errors.push('Duplicate enumeration IDs: '+eids.join(', '));
    }
    // duplicate cids?
    for (let e of this.state.type) {
      const cids = e.choices.map(c=>c.id);
      if (new Set(cids).size<cids.length) {
        errors.push('Duplicate choice IDs in enumeration "'+e.id+'": '+cids.join(', '));
      }
    }
    return errors;
  }
  handleSubmit = ()=>{
    console.log("TypeEditorModal::handleSubmit()");
    console.log("state:", this.state);
    const type = cloneType(this.state.type);
    this.props.onSubmit(type);
  }
  getChoiceFor = (eid, cid)=>{
    //console.log("TypeEditorModal::getChoiceFor()", eid, cid);
    const e = this.state.type.find(e=>e.id===eid);
    const c = e.choices.find(c=>c.id===cid);
    return c;
  }
  render() {
    //console.log("TypeEditorModal::render()");
    //console.log("this.props:", this.props);
    //console.log("this.state:", this.state);
    return (
      <Modal
        open={this.props.open}
        closeOnEscape={false}
        closeOnDimmerClick={false}
        onClose={this.props.onCancel}
      >
        <Header as='h2' icon='browser' content='Edit Selection Type' />
        <Modal.Content>
          <Form onSubmit={this.handleSubmit}>
            <p>
              A selection type consists of one or more <strong>enumerations</strong>
              (often just one).
              Each enumeration consists of one or more mutually exclusive <strong>choices</strong>
              (represented as toggle buttons).
            </p>
            <TypeEditorExampleSelector
              type={this.state.type}
              exampleItem={this.state.exampleItem}
              onToggleExampleItem={this.handleToggleExampleItem}
            />
            <p>
              Configure the type by adding, modifying, and removing
              enumerations and their choices:
            </p>
            {
              this.state.type.map((e,ei)=>
                <TypeEditorEnumPane
                  key={ei}
                  enu={e}
                  onSetEnumId={newId=>this.handleSetEnumId(ei, newId)}
                  onSetEnumName={newName=>this.handleSetEnumField(ei, 'name', newName)}
                  onSetEnumDescription={newDescription=>this.handleSetEnumField(ei, 'description', newDescription)}
                  onRemoveEnum={()=>this.handleRemoveEnum(ei)}
                  onAddEnumChoice={()=>this.handleAddEnumChoice(ei)}
                  onSetEnumChoiceId={(ci, newId)=>this.handleSetEnumChoiceId(ei, ci, newId)}
                  onSetEnumChoiceName={(ci, newName)=>this.handleSetEnumChoiceName(ei, ci, newName)}
                  onSetEnumChoiceDescription={(ci, newDescription)=>this.handleSetEnumChoiceDescription(ei, ci, newDescription)}
                  onSetEnumChoiceColor={(ci, newColor)=>this.handleSetEnumChoiceColor(ei, ci, newColor)}
                  onSetEnumChoiceIcon={(ci, newIcon)=>this.handleSetEnumChoiceIcon(ei, ci, newIcon)}
                  onRemoveEnumChoice={ci=>this.handleRemoveEnumChoice(ei, ci)}
                />
              )
            }
            <Button type='button' color='orange' onClick={this.handleAddEnum}>Add Enumeration</Button>
            {
              this.getTypeErrors().length
              ?
                <Message negative>
                  <Message.Header>Problem</Message.Header>
                  <p>{this.getTypeErrors()}</p>
                </Message>
              :
                null
            }
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={this.props.onCancel}>Cancel</Button>
          <Button disabled={!!this.getTypeErrors().length} primary onClick={this.handleSubmit}>Update</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default TypeEditorModal